import { HttpResponseBody } from '../interfaces';
import { isArrayBuffer } from '../../common/utils/stringify';

export type BasicResponseBody =
  | ArrayBuffer
  | Blob
  | string
  | string
  | undefined;

export const isBasicResponseBody = (
  obj?: unknown
): obj is BasicResponseBody => {
  return (
    isArrayBuffer(obj) ||
    obj instanceof Blob ||
    typeof obj === 'string' ||
    obj instanceof String ||
    typeof obj === 'undefined'
  );
};

export const makeResponseBody = (
  body: HttpResponseBody | undefined
): BasicResponseBody => {
  if (isBasicResponseBody(body)) {
    return body;
  } else if (typeof body === 'object') {
    return JSON.stringify(body);
  }
  return undefined;
};
